import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const openCompanyWebsite = () => {
    window.open('https://araknerd.com/', '_blank');
  };

  return (
    <div className="main-footer text-center">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <span>
              &copy; {new Date().getFullYear()} OpenFi by{' '}
              <Link to="#" onClick={openCompanyWebsite}>
                Araknerd Company Ltd
              </Link>
              .
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
